import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=6981d812&scoped=true"
import script from "./CommentBlock.vue?vue&type=script&lang=js"
export * from "./CommentBlock.vue?vue&type=script&lang=js"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&id=6981d812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981d812",
  null
  
)

export default component.exports